"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CheckCircle = _interopRequireDefault(require("@kyruus/react-ikons/CheckCircle"));
var _styles = require("./styles");
const RadioButton = _ref => {
  let {
    name,
    option,
    buttonStyle,
    row,
    checked,
    onChange
  } = _ref;
  const id = name == null ? option.value : `${name}-${option.value}`;
  return /*#__PURE__*/_react.default.createElement(_styles.StyledRadioButton, {
    row: row,
    buttonStyle: buttonStyle
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    id: id,
    name: name,
    value: option.value,
    checked: checked,
    onChange: onChange,
    "data-testid": `radio-${id}`,
    disabled: option.disabled,
    "aria-checked": checked,
    "aria-label": option.label,
    "aria-describedby": option.ariaDescribedby
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    "data-testid": `radio-label-${id}`
  }, /*#__PURE__*/_react.default.createElement("span", null, option.label), /*#__PURE__*/_react.default.createElement("span", {
    className: "checkmark",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement(_CheckCircle.default, null))), option.description);
};
exports.RadioButton = RadioButton;
RadioButton.propTypes = {
  /**
   * The name property to apply to the form group
   */
  name: _propTypes.default.string,
  /**
   * Whether or not the radio is checked
   */
  checked: _propTypes.default.bool,
  /**
   * Callback for handling changes to the selected radio button
   * args: (event, optionString)
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * The option to create the radio buttons for.
   * Example: {value: 'f', label: 'Female'}
   */
  option: _propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    buttonStyle: _propTypes.default.oneOf(['primary', 'secondary']),
    ariaDescribedby: _propTypes.default.string,
    /** An element containing a descriptive text for screen readers */
    description: _propTypes.default.node,
    disabled: _propTypes.default.bool
  }).isRequired,
  /**
   * Whether to display the buttons in a row (when false buttons are displayed in a single column)
   */
  row: _propTypes.default.bool,
  /**
   * Styles to apply when operating in buttons mode
   */
  buttonStyle: _propTypes.default.oneOf(['primary', 'secondary'])
};
RadioButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RadioButton",
  "props": {
    "name": {
      "description": "The name property to apply to the form group",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "checked": {
      "description": "Whether or not the radio is checked",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "description": "Callback for handling changes to the selected radio button\nargs: (event, optionString)",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "option": {
      "description": "The option to create the radio buttons for.\nExample: {value: 'f', label: 'Female'}",
      "type": {
        "name": "shape",
        "value": {
          "value": {
            "name": "string",
            "required": true
          },
          "label": {
            "name": "string",
            "required": true
          },
          "buttonStyle": {
            "name": "enum",
            "value": [{
              "value": "'primary'",
              "computed": false
            }, {
              "value": "'secondary'",
              "computed": false
            }],
            "required": false
          },
          "ariaDescribedby": {
            "name": "string",
            "required": false
          },
          "description": {
            "name": "node",
            "description": "An element containing a descriptive text for screen readers",
            "required": false
          },
          "disabled": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": true
    },
    "row": {
      "description": "Whether to display the buttons in a row (when false buttons are displayed in a single column)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "buttonStyle": {
      "description": "Styles to apply when operating in buttons mode",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }]
      },
      "required": false
    }
  }
};